import { RootState } from "../rootReducer";

export const assistantPages = (state: RootState) =>
  state.AssistantPagesReducer.assistantPages;

export const isLoading = (state: RootState) =>
  state.AssistantPagesReducer.isLoading;

export const assistantPage = (state: RootState) =>
  state.AssistantPagesReducer.assistantPage;

export const isSuccessOpen = (state: RootState) =>
  state.AssistantPagesReducer.isSuccessOpen;
